import { FC } from 'react'
import cn from 'classnames'
import * as styles from 'components/atoms/ProgressBar/ProgressBar.styl'
import themes from 'styles/base/themes.styl'
import { animated, config, useSpring } from '@react-spring/web'
import { Theme } from 'interfaces/component'

export type ProgressBarProps = {
  autoLoadTime?: number
  progressPercent: number | null // in %
  pinToTop?: boolean
  isLoading?: boolean
  theme?: Theme
}

const ProgressBar: FC<ProgressBarProps> = (props) => {
  const {
    progressPercent = null,
    autoLoadTime,
    isLoading,
    pinToTop,
    theme = 'cyan',
  } = props

  const animatedWidth = useSpring({
    config: !!autoLoadTime ? { duration: autoLoadTime } : config.gentle, // Some kind of issue. Can't control speed.,
    to: { width: progressPercent + '%' },
    from: { width: autoLoadTime ? '0%' : undefined },
  })

  const percentIsANumber = typeof progressPercent === 'number'
  const progressClassName = cn(
    styles.progressBar, {
      [styles.invisible]: progressPercent === null && !isLoading,
      [styles.pinToTop]: pinToTop,
    }
  )

  return (
    <div className={ progressClassName } >
      <animated.div
        className={ cn(styles.progressBarProgress, themes[theme]) }
        style={ !percentIsANumber && !isLoading ? { width: '0%' } : animatedWidth }
        role='progressbar'
      />
    </div>
  )
}

export default ProgressBar
